import styled from 'styled-components';
import { Stack } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/info.svg';
import OverflowTooltip from '../OverflowTooltip';
import { radius, space } from '../../style/utils';

const Wrapper = styled(Stack)<{ $fullWidth?: boolean }>`
  align-items: center;
  padding: ${space(0, 'smMinus')};
  background-color: ${({ theme }) => theme.palette.surface.strong};
  border-radius: ${radius('xxs')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '250px')};

  & svg {
    color: ${({ theme }) => theme.palette.accent.link};
    margin-left: ${space('xxsPlus')};
  }
`;

const OverflowInfo = ({
  value,
  fullWidth,
}: {
  value: string;
  fullWidth?: boolean;
}) => (
  <Wrapper direction="row" sx={{ alignItems: 'center' }} $fullWidth={fullWidth}>
    <OverflowTooltip icon={InfoIcon}>{value}</OverflowTooltip>
  </Wrapper>
);

export default OverflowInfo;
